<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="datatable.queries.per_page"
                      class="ml-1 mr-1"
                      size="sm"
                      :options="[10, 15, 25, 50, 100]"
                      @change="onQueryChange"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <SearchInput
                  v-model="datatable.queries.search"
                  @search="onQueryChange('search')"
                />
              </div>
            </div>
            <template v-if="!fetching">
              <div class="table-responsive mb-0">
                <b-table
                  :items="businesses"
                  :fields="datatable.columns"
                  :sort-by.sync="datatable.queries.sort_by"
                  :sort-desc.sync="datatable.queries.sort_desc"
                  :per-page="datatable.queries.per_page"
                  :no-local-sorting="true"
                  @sort-changed="onQueryChange"
                >
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                  <template v-slot:cell(active)="">
                    <feather type="check" class="icon-dual-success" />
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-button
                      variant="primary"
                      size="sm"
                      title="Restore"
                      :disabled="loadingRestore !== null"
                      @click="restore(data.item.id)"
                    >
                      <b-spinner v-if="loadingRestore === data.item.id" small />
                      <i v-else class="uil uil-refresh"></i>
                    </b-button>
                    <b-button
                      variant="danger"
                      size="sm"
                      title="Delete"
                      class="ml-1"
                      :disabled="loadingRemove === data.item.id"
                      @click="remove(data.item)"
                    >
                      <b-spinner v-if="loadingRemove === data.item.id" small />
                      <i v-else class="uil uil-trash"></i>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row mt-4">
                <div class="col">
                  <div class="float-left mt-2">
                    Total {{ totalBusinesses }} businesses
                  </div>
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="datatable.queries.page"
                        :total-rows="totalBusinesses"
                        :per-page="datatable.queries.per_page"
                        @change="onQueryChange"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="text-center">
              <b-spinner></b-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showDeleteModal" title="Delete agency">
      <p v-if="selectedBusiness"
        >Are you sure you want to permanently delete business <b>"{{
          selectedBusiness.name
        }}"</b>?</p
      >
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showDeleteModal = false"
          >Cancel</b-button
        >
        <b-button variant="danger" @click="handleRemove">Delete</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SearchInput from '@components/Common/SearchInput.vue'

export default {
  components: {
    SearchInput,
  },
  data() {
    return {
      datatable: {
        columns: [
          { key: 'id', label: '#', sortable: true },
          { key: 'name', sortable: true },
          { key: 'owner.email', label: 'Email', sortable: true },
          { key: 'agency.name', label: 'Agency', sortable: true },
          { key: 'actions' },
        ],
        queries: {
          per_page: 10,
          page: 1,
          status: 'archived',
          search: null,
          sort_by: 'id',
          sort_desc: false,
        },
      },
      loadingRestore: null,
      loadingRemove: null,
      selectedBusiness: null,
      showDeleteModal: false,
    }
  },

  computed: {
    ...mapState('business', {
      fetching: 'fetching',
      didFetch: 'didFetch',
      queries: 'queries',
      businesses: 'businesses',
      totalBusinesses: 'total',
    }),
  },

  watch: {
  },

  created() {
  },

  mounted() {
    this.$store.dispatch('business/resetAll')
      .then(() => {
        this.onQueryChange();
      })
  },

  methods: {
    onQueryChange(type = undefined) {
      this.$nextTick(() => {
        if (type === 'search')
        {
          this.datatable.queries.page = 1;
        }
        this.$store.commit('business/updateState', {
          queries: {
            per_page: this.datatable.queries.per_page,
            page: this.datatable.queries.page,
            status: this.datatable.queries.status,
            search: this.datatable.queries.search,
            sort_by: this.datatable.queries.sort_by,
            sort_desc: this.datatable.queries.sort_desc,
          }
        })
        this.getBusinesses()
      });
    },

    getBusinesses() {
      this.$store
        .dispatch('business/getAll')
    },

    restore(businessId) {
      this.loadingRestore = businessId

      this.$store
        .dispatch('business/restore', businessId)
        .then(() => {
          this.loadingRestore = null
          this.getBusinesses()
        })
        .catch(() => {
          this.loadingRestore = null
        })
    },

    remove(business) {
      this.showDeleteModal = true
      this.selectedBusiness = business
    },

    handleRemove() {
      this.showDeleteModal = false
      this.loadingRemove = this.selectedBusiness.id
      this.$store
        .dispatch('business/delete', this.selectedBusiness.id)
        .then(() => {
          this.loadingRemove = null
          this.getBusinesses()
        })
        .catch(() => {
          this.loadingRemove = null
        })
    },
  },
}
</script>
